// utils/currencyUtils.js

// Helper functions that work in both environments
const formatDateForCNB = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };
  
  const parseCNBResponse = (data) => {
    try {
      const lines = data.split('\n').filter(line => line.trim());
      
      if (lines.length < 3) {
        throw new Error('Invalid data format from CNB');
      }
  
      const rates = {};
      
      // Skip first two lines (header and table header)
      for (let i = 2; i < lines.length; i++) {
        const [country, currency, amount, code, rate] = lines[i].split('|');
        if (code && rate) {
          try {
            const unitRate = parseFloat(rate.replace(',', '.')) / parseInt(amount);
            if (!isNaN(unitRate)) {
              rates[code] = unitRate;
            }
          } catch (e) {
            console.error('Error parsing rate for currency:', code, e);
          }
        }
      }
  
      // Add CZK with rate 1
      rates['CZK'] = 1;
  
      return rates;
    } catch (error) {
      console.error('Error parsing CNB response:', error);
      throw new Error('Failed to parse exchange rates data');
    }
  };
  
  const calculateConversionRate = (rates, fromCurrency, toCurrency) => {
    if (!rates[fromCurrency] || !rates[toCurrency]) {
      throw new Error(`Missing rate for ${!rates[fromCurrency] ? fromCurrency : toCurrency}`);
    }
  
    return rates[fromCurrency] / rates[toCurrency];
  };
  
  // CommonJS module exports
  module.exports = {
    formatDateForCNB,
    parseCNBResponse,
    calculateConversionRate
  };